import React from 'react'
import { useTranslation } from "react-i18next";
import {Link} from "react-router-dom";

const helpBox = (props) => {

    const { t } = useTranslation();
    let type = (props.type == 'budget' || props.type == 'invoice' || props.type == 'budget-2' || props.type == 'ppa' || props.type == 'ppa-2') ? props.type : 'contact';
    let cta = props.cta ? true : false;
    let helpboxClasses = cta ? 'helpbox helpbox--with-cta' : 'helpbox';
	let layout = props.column ? 'column' : 'row'
	let layoutClasses =`helpbox--${layout}`

    let hrefTo = t(`helpbox.${type}.link.href`);
    let targetTo = '_self';

    if (type == 'contact') {
        hrefTo = { pathname: t(`helpbox.${type}.link.href`) }
        targetTo = '_blank';
    }

	if (props.classes) {
		helpboxClasses = `${helpboxClasses} ${props.classes}`
	}

    return (
        <div className={`${helpboxClasses} helpbox--${type} ${layoutClasses}`} >
            <div className="helpbox__inner flex flex--align-center flex--wrap">

                <div className="helpbox__content flex flex--align-center flex--justify-space-between">

                    <div className="helpbox__headline flex flex--align-center">
                        <div className="helpbox__icon">
                            <i className={t(`helpbox.${type}.icon`)}></i>
                        </div>

                        <div className="headline">

                            <h4 className="headline headline--sub headline--c-red">
								{t(`helpbox.${type}.title`)}
							</h4>

							{(props.text)  && <p className="p p--margin--0">
								{t(`helpbox.${type}.text`)}
							</p>}

                            {!cta &&
                                <Link className="helpbox__link link link--underline link--fs-14"
                                      target={targetTo}
                                      to={hrefTo}>
                                    <strong>{t(`helpbox.${type}.link.title`)}</strong>
                                </Link>
                            }
                        </div>&nbsp;
                    </div>

                    {type == 'contact' &&
                        <React.Fragment>
                            <span className="helpbox__line"></span>
                            <small className="helpbox__contact">
                                {t("helpbox.contact.quebec")} : <strong><a href="tel:+14507597979" target="_blank">450 759-7979</a> | <a href="tel:+18003632712" target="_blank">1 800 363-2712 #1515</a></strong><br/>
                                {t("helpbox.contact.fax")} : <strong>450 759-7001</strong>
                            </small>
                        </React.Fragment>
                    }
                </div>


                {cta  &&
                    <Link className="helpbox__btn btn btn--outline btn--outline--lightgray"
                          target={targetTo}
                          to={hrefTo}>
                        <strong>{t(`helpbox.${type}.link.title`)}</strong>
                    </Link>
                }
            </div>
        </div>
    );
};

export default helpBox;
